// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__z79H3","itemTitle":"ClientEmergencyInfo_itemTitle__KKstF","itemText":"ClientEmergencyInfo_itemText__2QJcN"};